import styled from 'styled-components'
import Colors from '../../../../themes/Colors'

// Content of the breadcrumb ellipsis popover (the hidden intermediate folders).
// Rendered in an antd portal outside any holder, so it needs its own styled
// component rather than a nested selector.
const BreadcrumbHiddenList = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 160px;

  .bc-hidden-item {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 6px 8px;
    border-radius: 4px;
    cursor: pointer;
    color: ${Colors.coal};

    .anticon {
      color: ${Colors.primaryAccent};
    }

    &:hover {
      background: ${Colors.extraLightPrimary};
      color: ${Colors.primaryAccent};
    }
  }

  /* Read-only variant (informational only, e.g. the upload modal): no click. */
  &.read-only .bc-hidden-item {
    cursor: default;

    &:hover {
      background: transparent;
      color: ${Colors.coal};
    }
  }
`

export default BreadcrumbHiddenList
